class Regex {
    constructor(props) {
    }

    // numeric regex
    static numeric() {
        return /^-?\d*\.?\d*$/
    }
    // Email regex
    static email() {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    }

    // Aadhaar
    static aadhaar() {
        return /^\d{12}$/
    }
    // Mobile
    static mobile() {
        return /^[6-9]\d{9}$/
    }
}


// export
export default Regex